export default [
  {
    id: 101000000,
    value: '金融服务',
    children: [
      {
        id: 101201000,
        value: '彩票',
        children: [],
        parentId: 101000000,
        type: 'INTEREST_BI'
      },
      {
        id: 101206000,
        value: '保险',
        children: [
          {
            id: 101206500,
            value: '寿险',
            children: [],
            parentId: 101206000,
            type: 'INTEREST_BI'
          }
        ],
        parentId: 101000000,
        type: 'INTEREST_BI'
      },
      {
        id: 101205000,
        value: '银行理财',
        children: [],
        parentId: 101000000,
        type: 'INTEREST_BI'
      },
      {
        id: 101204000,
        value: '股票基金',
        children: [],
        parentId: 101000000,
        type: 'INTEREST_BI'
      },
      {
        id: 101202000,
        value: '期货外汇',
        children: [],
        parentId: 101000000,
        type: 'INTEREST_BI'
      },
      {
        id: 101203000,
        value: '互联网金融',
        children: [],
        parentId: 101000000,
        type: 'INTEREST_BI'
      },
      {
        id: 101208000,
        value: '借贷服务',
        children: [],
        parentId: 101000000,
        type: 'INTEREST_BI'
      },
      {
        id: 101207000,
        value: '信用卡',
        children: [],
        parentId: 101000000,
        type: 'INTEREST_BI'
      }
    ],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 102000000,
    value: '游戏',
    children: [
      {
        id: 102401000,
        value: 'ARPG',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102402000,
        value: 'SLG',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102405000,
        value: '经营养成',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102305000,
        value: '战争',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102306000,
        value: '西游',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102411000,
        value: '休闲益智',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102325000,
        value: '消除',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102330000,
        value: '仙侠玄幻',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102302000,
        value: '仙侠',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102407000,
        value: '塔防',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102313000,
        value: '武侠',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102412000,
        value: '体育',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102410000,
        value: '射击',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102413000,
        value: '沙盒',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102304000,
        value: '三国',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102311000,
        value: '日漫',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102324000,
        value: '赛车',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102303000,
        value: '奇迹',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102327000,
        value: '棋牌',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102409000,
        value: '游戏平台',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102310000,
        value: '末日',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102307000,
        value: '魔幻',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102414000,
        value: 'MOBA',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102308000,
        value: '冒险',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102315000,
        value: '科幻',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102404000,
        value: '卡牌',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102403000,
        value: '回合制',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102322000,
        value: '国漫',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102319000,
        value: '鬼畜',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102318000,
        value: '宫斗',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102321000,
        value: '足球',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102408000,
        value: '放置',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102309000,
        value: '二次元',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102316000,
        value: '都市',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102406000,
        value: '动作',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102312000,
        value: '盗墓',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102301000,
        value: '传奇',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102323000,
        value: '吃鸡',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      },
      {
        id: 102314000,
        value: '暗黑',
        children: [],
        parentId: 102000000,
        type: 'INTEREST_BI'
      }
    ],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 103000000,
    value: '房产',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 104000000,
    value: '汽车',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 105000000,
    value: '服饰箱包',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 107000000,
    value: '家装百货',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 108000000,
    value: '生活服务',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 113000000,
    value: '教育培训',
    children: [
      {
        id: 113006000,
        value: '资格证考试',
        children: [
          {
            id: 113006300,
            value: '财经类考试',
            children: [],
            parentId: 113006000,
            type: 'INTEREST_BI'
          },
          {
            id: 113006100,
            value: '医学类资格考试',
            children: [],
            parentId: 113006000,
            type: 'INTEREST_BI'
          },
          {
            id: 113006800,
            value: '心理咨询师考试',
            children: [],
            parentId: 113006000,
            type: 'INTEREST_BI'
          },
          {
            id: 113006200,
            value: '教师资格考试',
            children: [],
            parentId: 113006000,
            type: 'INTEREST_BI'
          },
          {
            id: 113006600,
            value: '消防师资格考试',
            children: [],
            parentId: 113006000,
            type: 'INTEREST_BI'
          }
        ],
        parentId: 113000000,
        type: 'INTEREST_BI'
      },
      {
        id: 113001000,
        value: 'K12',
        children: [
          {
            id: 113001200,
            value: '小学教育',
            children: [],
            parentId: 113001000,
            type: 'INTEREST_BI'
          },
          {
            id: 113001300,
            value: '中学教育',
            children: [],
            parentId: 113001000,
            type: 'INTEREST_BI'
          },
          {
            id: 113001500,
            value: '小初高教育',
            children: [],
            parentId: 113001000,
            type: 'INTEREST_BI'
          },
          {
            id: 113001400,
            value: '高中教育',
            children: [],
            parentId: 113001000,
            type: 'INTEREST_BI'
          },
          {
            id: 113001600,
            value: '素质教育',
            children: [],
            parentId: 113001000,
            type: 'INTEREST_BI'
          }
        ],
        parentId: 113000000,
        type: 'INTEREST_BI'
      },
      {
        id: 113003000,
        value: '学历培训',
        children: [
          {
            id: 113003100,
            value: '研究生教育',
            children: [],
            parentId: 113003000,
            type: 'INTEREST_BI'
          },
          {
            id: 113003200,
            value: '成人教育',
            children: [],
            parentId: 113003000,
            type: 'INTEREST_BI'
          }
        ],
        parentId: 113000000,
        type: 'INTEREST_BI'
      },
      {
        id: 113004000,
        value: '语言培训',
        children: [
          {
            id: 113004100,
            value: '成人英语',
            children: [],
            parentId: 113004000,
            type: 'INTEREST_BI'
          }
        ],
        parentId: 113000000,
        type: 'INTEREST_BI'
      }
    ],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 106000000,
    value: '食品餐饮',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 109000000,
    value: '旅游出行',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 110000000,
    value: '数码科技',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 114000000,
    value: '体育运动',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 111000000,
    value: '美容整形',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 112000000,
    value: '母婴儿童',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 117000000,
    value: '医疗健康',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 118000000,
    value: '商务服务',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 115000000,
    value: '文化娱乐',
    children: [
      {
        id: 115001000,
        value: '小说',
        children: [
          {
            id: 115001100,
            value: '免费小说',
            children: [],
            parentId: 115001000,
            type: 'INTEREST_BI'
          },
          {
            id: 115001200,
            value: '乡村',
            children: [],
            parentId: 115001000,
            type: 'INTEREST_BI'
          },
          {
            id: 115001300,
            value: '历史',
            children: [],
            parentId: 115001000,
            type: 'INTEREST_BI'
          },
          {
            id: 115001400,
            value: '都市',
            children: [],
            parentId: 115001000,
            type: 'INTEREST_BI'
          },
          {
            id: 115001500,
            value: '玄幻言情',
            children: [],
            parentId: 115001000,
            type: 'INTEREST_BI'
          },
          {
            id: 115001600,
            value: '悬疑',
            children: [],
            parentId: 115001000,
            type: 'INTEREST_BI'
          },
          {
            id: 115001700,
            value: '古代言情',
            children: [],
            parentId: 115001000,
            type: 'INTEREST_BI'
          },
          {
            id: 115001800,
            value: '玄幻奇幻',
            children: [],
            parentId: 115001000,
            type: 'INTEREST_BI'
          },
          {
            id: 115001900,
            value: '仙侠奇缘',
            children: [],
            parentId: 115001000,
            type: 'INTEREST_BI'
          },
          {
            id: 115001110,
            value: '霸道总裁',
            children: [],
            parentId: 115001000,
            type: 'INTEREST_BI'
          }
        ],
        parentId: 115000000,
        type: 'INTEREST_BI'
      }
    ],
    parentId: -1,
    type: 'INTEREST_BI'
  },
  {
    id: 119000000,
    value: '政法服务',
    children: [],
    parentId: -1,
    type: 'INTEREST_BI'
  }
]
